// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconPhonePath = 'M13.002 0c-1.654 0-3 1.346-3 3v7.42l2.329-1.567A4.99 4.99 0 0 1 15.127 8h1.875c1.654 0 3-1.346 3-3V0h-7Zm5 5c0 .551-.45 1-1 1h-1.875a6.987 6.987 0 0 0-3.125.734V3c0-.551.449-1 1-1h5v3ZM5.78 16.242a8.852 8.852 0 0 0 5.577 1.72 8.869 8.869 0 0 0 3.105-.646l-2.615-3.363-.67.513a3.247 3.247 0 0 1-4.524-.581L4.94 11.684a3.218 3.218 0 0 1-.657-2.401 3.215 3.215 0 0 1 1.242-2.157l.635-.487L3.75 3.538a9.004 9.004 0 0 0-1.736 5.61 9.087 9.087 0 0 0 .626 3.064 8.954 8.954 0 0 0 3.14 4.03Zm2.452-3.586a1.24 1.24 0 0 0 1.729.223l2.246-1.721 5.3 6.819-1.005.57a11.028 11.028 0 0 1-5.421 1.42 10.91 10.91 0 0 1-6.472-2.104A10.944 10.944 0 0 1 .777 12.94a11.087 11.087 0 0 1-.762-3.733 11.005 11.005 0 0 1 3.038-7.95l.8-.844 5.122 6.587-2.232 1.71a1.235 1.235 0 0 0-.224 1.744l1.714 2.2Z';
var IconPhone = baseIcon('IconPhone', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconPhonePath
});
export default IconPhone;
//# sourceMappingURL=index.js.map